import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ptBR from "./locales/pt-BR.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

// Single source of truth for supported locales. Used by the language
// switcher to render its options + by html[lang] sync.
export const SUPPORTED_LANGS = [
  { code: "pt-BR", label: "Português", short: "PT" },
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pt-BR",
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    interpolation: { escapeValue: false }, // React already escapes
    resources: {
      "pt-BR": { translation: ptBR },
      en: { translation: en },
      es: { translation: es },
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "yorwha:lang",
    },
    returnObjects: true, // so we can read arrays (project features) directly
  });

// Keep <html lang="..."> in sync so screen readers + browser translation
// detection get the right hint.
const syncHtmlLang = (lng) => {
  if (typeof document !== "undefined") document.documentElement.lang = lng;
};
i18n.on("languageChanged", syncHtmlLang);
syncHtmlLang(i18n.language);

export default i18n;
